module.exports = require('./helpers/bundle-url').getBundleURL('f6ego') + "logo.c51670a8.svg";